import gql from 'graphql-tag';

export const getMostRecentMeterReadingValues = gql(/* GraphQL */ `
  query getMostRecentMeterReadingValues($equipmentId: UUID!) {
    getMostRecentMeterReadingValues(equipmentId: $equipmentId) {
      createdAt
      value
      meterReadingSettingId
    }
  }
`);
